<template>
	<div>
		<Transition name="slide-in-top">
			<div
				v-if="showRemainingSlots && !hasAppointmentInFuture && (showToday || showTomorrow)"
				class="flex justify-center items-center gap-4 bg-gradient-to-r from-purple-900 via-purple-800 to-purple-900 md:text-center p-5 text-functional-size-sm md:text-functional-size-md font-display font-medium border-y border-purple-700 shadow-inner shadow-purple-900/50"
			>
				<p
					v-if="showToday"
					class="leading-normal inline-block rounded text-purple-100"
				>
					We hebben vandaag nog maar
					<span class="border-2 mx-1 border-yellow-100 text-yellow-100 px-2 rounded font-bold">{{ remainingSlots.today }}</span> <span v-if="remainingSlots.today === 1">plaats</span><span v-else>plaatsen</span> beschikbaar!
				</p>
				<p
					v-else-if="showTomorrow"
					class="leading-normal inline-block rounded text-purple-100"
				>
					We hebben morgen nog maar
					<span class="border-2 mx-1 border-yellow-100 text-yellow-100 px-2 rounded font-bold">{{ remainingSlots.tomorrow }}</span> <span v-if="remainingSlots.tomorrow === 1">plaats</span><span v-else>plaatsen</span> beschikbaar!
				</p>
				<button
					class="animate-pulse inline-flex items-center gap-3 border-2 border-yellow-100 text-yellow-100 px-3 py-1 rounded"
					@click="openAppointmentDialog"
				>
					Plaats reserveren
					<AtomFontAwesome
						class="size-4"
						icon="fa-chevron-right"
					/>
				</button>
			</div>
		</Transition>
	</div>
</template>

<script lang="ts" setup>
const {
	remainingSlots,
	hasAppointmentInFuture,
} = useAppointmentPlanner();

const {
	openAppointmentDialog,
} = useDialogs();

const showRemainingSlots = ref(false);

const showToday = computed(() => remainingSlots.value.today > 0 && remainingSlots.value.today <= 5);
const showTomorrow = computed(() => remainingSlots.value.tomorrow > 0 && remainingSlots.value.tomorrow <= 5);

onMounted(() => {
	setTimeout(() => {
		showRemainingSlots.value = true;
	}, 200);
});
</script>
